var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNewLong = function SvgIconNewLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FB4E4E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.044.5v6H3.96L1.303 2.688h-.05V6.5H0v-6h1.102l2.64 3.812H3.8V.5h1.244ZM6.063 6.5v-6h4.06v1.028H7.315v1.458h2.597v1.028H7.316v1.458h2.814V6.5H6.063ZM12.452 6.5l-1.729-6h1.37l1.02 4.193h.05L14.272.5h1.178l1.11 4.202h.05L17.631.5H19l-1.729 6h-1.227L14.89 2.539h-.05L13.68 6.5h-1.228Z"
  }))));
};
export default SvgIconNewLong;